import axios from "axios";
import { mapKeys, camelCase, snakeCase } from "lodash-es";

export const csrftoken = document.head.querySelector("[name='csrf-token']")
  .attributes.content.value;

axios.defaults.headers.common["X-CSRF-Token"] = csrftoken;

export const apiClient = axios.create();

export const formRequestHeader = {
  Accept: "application/json",
  "X-CSRF-Token": csrftoken,
  "X-Requested-With": "XMLHttpRequest",
};
export const mediaHeader = {
  Accept: "*/*",
  "X-CSRF-Token": csrftoken,
  "X-Requested-With": "XMLHttpRequest",
};

export const requestHeader = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-CSRF-Token": csrftoken,
  "X-Requested-With": "XMLHttpRequest",
};

export function apiDeserializer(dataObj) {
  return mapKeys(dataObj, (value, key) => camelCase(key));
}
export function apiSerializer(dataObj) {
  return mapKeys(dataObj, (value, key) => snakeCase(key));
}
